module.exports = __webpack_public_path__ + "static/media/prod1.b6aa0de5.jpg";